module.exports = __webpack_public_path__ + "img/P2 (3).df66751e.png";